import { fromJS } from 'immutable';
import * as ReducerACtions from './actions';

const initialState = fromJS({
    data: {
        proveedores: undefined,
        proveedorEdit: undefined
    }
});

export default function proveedoresReducer(state = initialState, action) {
    
    if(action.type === ReducerACtions.SET_PROVEEDORES){
        return state.setIn(["data", "proveedores"], action.payload);
    }

    if(action.type === ReducerACtions.SAVE_PROVEEDOR){
        return state.setIn(["data", "proveedorEdit"], action.payload);
    }

    return state;
}